<template>
  <div>
    <div >
      <s-msg ref="localisation_save">
        Votre localisation du club a été sauvegardée
      </s-msg>
      <div style="padding:5px">
      <label class="title is-3">
        <s-button icon="undo" theme="is-warning" label="" @onclick="$emit('back')"/>
        Positionnez votre club {{club.name}}</label>
      
        </div>
        <gmap-autocomplete
          class="input is-rounded is-info"
          placeholder="Saisir l'adresse"
          :value="search"
          @place_changed="setPlace"
          :options="{fields: ['geometry', 'formatted_address']}"
          >
        </gmap-autocomplete>
        <div style="padding-top:5px">
        <s-button @onclick="addMarker" icon="map-marker" label="Localiser" theme="is-primary"/>
        <div style="float:right">    
            <s-button icon="save" label="Enregistrer" theme="is-success" @onclick="save" :disabled="disabled"/>
        </div>
        </div>
      </label>
      

    </div><br/>
    
    <gmap-map
      :center="center"
      :zoom="zoom"
      style="width:100%;  height: 400px;" 
      ref="map"
    >
      <gmap-marker
        key="position"
        :position="position"
       
        :draggable="true"
         @drag="updateCoordinates" 
      ></gmap-marker>
    </gmap-map>
    <div class="notification is-warning">
    Si vous n'avez pas d'adresse exacte, vous pouvez déplacer le curseur pour le positionner exactement là où se trouve votre club
    </div>
  </div>
</template>

<script>
import club_fct from "@/firebase/club"
export default {
  name: "GoogleMap",
  props:["club"],
  data() {
    return {
      // default to montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 47, lng: 3 },
      position: {},
      places: [],
      currentPlace: null,
      zoom: 5,
      search: "",
      disabled: true
    };
  },

  mounted() {
    this.geolocate();
  },
  
  methods: {
    save() {
      this.disabled = true;
      this.club.position = this.position;
     // console.log(this.$refs.map[0].getZoom());
      this.$refs.map.$mapPromise.then((map) => {
        this.club.zoom = map.zoom;  
        if (this.currentPlace != null) {
            this.club.place = this.currentPlace.formatted_address;
        }
        club_fct.object.set(this.club, ()=>{
          this.$refs.localisation_save.showMsg();
        })
      })
       
     
    },
  
     updateCoordinates(location) {
       this.disabled = false;
       this.position = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        };
               
        },
    setPlace(place) {
      this.currentPlace = place;
    },
    mark(event) {
          
             
    },
    addMarker() {
      if (this.currentPlace) {
        this.disabled= false;
        this.position = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.center = this.position;
        this.search =  this.currentPlace.formatted_address;
      }
    },
    geolocate: function() {
      if (typeof(this.club.position)!="undefined") {
          this.position = this.club.position;
          this.zoom = this.club.zoom;
          this.center =  this.club.position;
           if (typeof(this.club.place)!="undefined") {
             this.search = this.club.place;
           }
      }
      else {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
      }
    }
  }
};
</script>
